import { render, staticRenderFns } from "./DistributionMonitoring.vue?vue&type=template&id=f6131038&scoped=true&"
import script from "./DistributionMonitoring.vue?vue&type=script&lang=js&"
export * from "./DistributionMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./DistributionMonitoring.vue?vue&type=style&index=0&id=f6131038&prod&lang=css&"
import style1 from "./DistributionMonitoring.vue?vue&type=style&index=1&id=f6131038&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6131038",
  null
  
)

export default component.exports